{
  "instances": {
    "quartz": {
      "actions": "Aktionen",
      "active_triggers": "Aktive Auslöser",
      "associated_triggers": "Zugeordnete Auslöser",
      "associated_with_calendar": "Mit Kalender assoziiert",
      "basic_information": "Grundinformationen",
      "calendar": "Kalender",
      "class": "Klasse",
      "configuration": "Konfiguration",
      "cron_expression": "Cron-Ausdruck",
      "custom_trigger": "Benutzerdefinierter Auslöser",
      "days_of_week": "Wochentage",
      "description": "Beschreibung",
      "details": "Details",
      "disabled": "Deaktiviert",
      "durable": "Persistent",
      "enabled": "Aktiviert",
      "end_time": "Endzeit",
      "final_fire_time": "Endgültige Ausführungszeit",
      "friday": "Freitag",
      "group": "Gruppe",
      "infinite": "Unbegrenzt",
      "interval": "Intervall",
      "job_data": "Jobdaten",
      "job_name": "Jobname",
      "jobs": "Jobs",
      "key": "Schlüssel",
      "label": "Quartz",
      "last_fire": "Letzte Ausführung",
      "last_fire_time": "Letzte Ausführungszeit",
      "monday": "Montag",
      "name": "Name",
      "next_fire": "Nächste Ausführung",
      "next_fire_time": "Nächste Ausführungszeit",
      "no": "Nein",
      "no_data": "Keine Quartz-Informationen verfügbar",
      "paused_triggers": "Pausierte Auslöser",
      "preserve_hour_of_day": "Tagesstunde beibehalten",
      "priority": "Priorität",
      "recovery": "Wiederherstellung",
      "repeat_count": "Anzahl Wiederholungen",
      "request_recovery": "Wiederherstellung anfordern",
      "saturday": "Samstag",
      "schedule_configuration": "Zeitplankonfiguration",
      "skip_day_if_hour_does_not_exist": "Tag überspringen, wenn Stunde nicht existiert",
      "start_time": "Startzeit",
      "state": "Status",
      "sunday": "Sonntag",
      "system_default": "Systemstandard",
      "thursday": "Donnerstag",
      "time_window": "Zeitfenster",
      "time_zone": "Zeitzone",
      "times_triggered": "Anzahl Auslösungen",
      "timing_information": "Zeitinformationen",
      "total": "insgesamt",
      "trigger_data": "Auslöserdaten",
      "trigger_failed": "Auslösung fehlgeschlagen",
      "trigger_failed_message": "Fehler beim Auslösen des Jobs: {error}",
      "trigger_failed_notification": "Fehler beim Auslösen des Jobs \"{jobName}\": {error}",
      "trigger_fire_times": "Auslösezeiten",
      "trigger_job_now": "Job jetzt auslösen",
      "trigger_success_message": "Job \"{jobName}\" erfolgreich ausgelöst",
      "trigger_success_title": "Job ausgelöst",
      "triggers": "Auslöser",
      "tuesday": "Dienstag",
      "type": "Typ",
      "value": "Wert",
      "wednesday": "Mittwoch",
      "yes": "Ja"
    }
  }
}
